import clientAPI from "@/api/ClientAPIMixin.js";
import ContractMixin from "@/helpers/Mixins/ContractMixin.js";
import LicencesMixin from "@/helpers/Mixins/LicencesMixin.js";
import DateTimeMixin from "@/helpers/Mixins/DateTimeMixin.js";
import LicenseKeys from "@/helpers/Constants/LicenseKeys";

export default {
  mixins: [clientAPI, ContractMixin, LicencesMixin, DateTimeMixin],

  data() {
    return {
      loading: false,
      contracts: null,
    };
  },

  computed: {
    hasContracts() {
      return Array.isArray(this.contracts) && this.contracts.length > 0;
    },
    hasContractOrQuotationLicense() {
      return this.checkIfLicencedByKey(`${LicenseKeys.Contract},${LicenseKeys.Quotation}`);
    },
    showNewContractViews() {
      return this.$store.state.GlobalSettings.ShowNewContractViews;
    },
  },

  methods: {
    async fetch() {
      // By default, try to read from this.machine?.Id if present
      const machineId = this.machine && this.machine.Id ? this.machine.Id : null;
      return this.fetchByMachineId(machineId);
    },

    async fetchByMachineId(machineId) {
      if (!this.hasContractOrQuotationLicense) {
        this.contracts = null;
        return;
      }
      if (!machineId) {
        this.contracts = null;
        return;
      }
      this.loading = true;
      try {
        this.contracts = await this.getMachineContractsById(machineId);
      } catch (e) {
        console.error(e);
        this.contracts = null;
      } finally {
        this.loading = false;
      }
    },

    contractRoute(detail) {
      let route;
      if (!this.showNewContractViews) {
        route = {
          name: "OldContractView",
          params: {
            contractId: detail.ContractId,
            contractTypeId: detail.Contract.ContractTypeId,
          },
        };
      } else {
        route = {
          name: this.getViewRouteFromContractType(detail.Contract.ContractTypeId),
          params: {
            contractId: detail.ContractId,
            contractTypeId: detail.Contract.ContractTypeId,
          },
        };
      }
      return route;
    },

    isPast(date) {
      if (!date) return false;
      const d = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return d.getTime() < today.getTime();
    },

    isWithinSixMonths(date) {
      if (!date) return false;
      const now = new Date();
      const target = new Date(date);
      const sixMonthsFromNow = new Date(
        now.getFullYear(),
        now.getMonth() + 6,
        now.getDate()
      );
      return (
        target.getTime() >= now.getTime() &&
        target.getTime() <= sixMonthsFromNow.getTime()
      );
    },

    detailStatus(detail) {
      // Only show time-based detail for monthly billing (type 0)
      const isMonthly = detail && detail.ContractType && detail.ContractType.Type === 0;
      if (!isMonthly) return "";

      const terminated = detail && detail.ContractTerminated;
      const endDate = detail && detail.ContractEnd;

      if (terminated) {
        // Future termination date -> show date
        if (!this.isPast(terminated)) {
          return `Terminates ${this.i18nFormatDate(terminated)}`;
        }
        // Already terminated
        return "Terminated";
      }

      if (endDate) {
        // Ended in the past
        if (this.isPast(endDate)) {
          return `Expired`;
        }
        return `Expires ${this.i18nFormatDate(endDate)}`;
      }

      return "";
    },

    detailStatusClass(detail) {
      const isMonthly = detail && detail.ContractType && detail.ContractType.Type === 0;
      if (!isMonthly) return "grey--text text--darken-1";

      const terminated = detail && detail.ContractTerminated;
      const endDate = detail && detail.ContractEnd;

      // ended
      if (endDate && this.isPast(endDate)) {
        return "error--text";
      }

      // termination scheduled or end within 6 months
      if (
        (terminated && this.isWithinSixMonths(terminated)) ||
        (endDate && this.isWithinSixMonths(endDate))
      ) {
        return "warning--text";
      }

      return "grey--text text--darken-1";
    },
  },
};

